<template>
<div class="contentGlobal">
    <div class="content inner">
        <div class="login boxLogin">
            <b-row>
                <b-col>
                    <!-- User profile -->
                    <h4>{{ $t("messages.userProfile") }}</h4>
                    <form @submit.prevent="profile">
                        <b-row :class="{ 'form-group--error': $v.userProfile.name.$error }">
                            <!-- Name -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.name") }}</label></b-col>
                            <b-col cols="10">
                                <!-- <b-form-input type="text" placeholder="name" v-model.trim="$v.userProfile.name.$model"></b-form-input> -->
                                <input class="form-control" v-model.trim="userProfile.name"/>
                            </b-col>  
                        </b-row>
                        <b-row v-if="$v.userProfile.$error">
                            <div class="error" v-if="!$v.userProfile.name.required">{{ $t('messages.login.error.required') }}</div>
                            <div class="error" v-if="!$v.userProfile.name.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.name"), value: $v.userProfile.name.$params.minLength.min }) }} </div>
                        </b-row >

                        <b-row class="mtop10">
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t('messages.login.country') }}</label></b-col>
                            <b-col cols="10">
                                <b-form-select class="form-control"  v-model="userProfile.country" :options="countries"/>
                            </b-col>  
                        </b-row>
                        <b-row v-if="$v.userProfile.$error">
                            <div class="error" v-if="!$v.userProfile.country.required">{{ $t('messages.login.error.required') }}</div>
                        </b-row >

                        <b-row class="mtop10">
                            <!-- Phone -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.login.phone") }}</label></b-col>
                            <b-col cols="10">
                            <b-form-input type="text" placeholder="phone" v-model.trim="userProfile.phone"></b-form-input></b-col>
                        </b-row>
  
                        <b-row class="mtop10">
                            <!-- Prefered language -->
                            <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.preferedLanguage") }}</label></b-col>
                            <b-col cols="10">
                                <select class="form-control" :required="true" v-model="userProfile.language">
                                    <option 
                                        v-for="option in languages" :key="option.code" 
                                        v-bind:value="option.code"
                                        :selected="option.code == userProfile.language"
                                        >{{ option.name }}
                                    </option>
                                </select>
                            </b-col>
                        </b-row>

                        <div v-if="pools.length > 0"> 
                            <h4 class="mtop20"> {{ $t("messages.voice") }}</h4>
                            <b-row class="form-group">
                                <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.enable_voice") }}</label></b-col>
                                    <b-col cols="6" class="text-left">
                                            <b-col cols="2" class="normal">
                                            <md-switch class="md-primary" v-model="userProfile.voice_enabled"></md-switch>
                                        </b-col>
                                    </b-col>
                            </b-row>
                
                        <b-row class="mtop10">
                                <b-col cols="2" class="right"><label class="w100 right">{{ $t("messages.select") }}</label></b-col>
                                <b-col cols="10">
                                    <select class="form-control" :required="true" v-model="userProfile.rooted_voice_pool">
                                        <option 
                                            v-for="option in pools" :key="option.id" 
                                            v-bind:value="option.id"
                                            :selected="option.id == userProfile.rooted_voice_pool"
                                            >{{ option.name }}
                                        </option>
                                    </select>
                                    <b-alert show variant="warning" style="margin-top:10px"> {{ $t("messages.info_voice") }} </b-alert> 
                                </b-col>
                            </b-row>
                        </div>
                        <!-- Update Profile -->
                        <button type="submit" class="button save">{{ $t("messages.updateProfile") }}</button>
                    </form>
                    <!-- Change password -->
                    <h4 class="mtop20">{{ $t("messages.changePassword") }}</h4>
                    <form @submit.prevent="submit">
                        <b-row class="form-group" :class="{ 'form-group--error': $v.form.password.$error }">
                            <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.password") }}</label></b-col>
                            <b-col cols="10"><input class="form-control" type="password" v-model.trim="$v.form.password.$model"/></b-col>
                        </b-row>
                        <b-row  v-if="$v.form.$error">
                            <div class="error" v-if="!$v.form.password.required">{{ $t('messages.login.error.required') }}</div>
                            <div class="error" v-if="!$v.form.password.minLength">{{ $t('messages.login.error.minLength', { field: $t("messages.login.password"), value: $v.form.password.$params.minLength.min }) }} </div>
                        </b-row>
            
                        <b-row class="form-group" :class="{ 'form-group--error': $v.form.repeatPassword.$error }">
                            <b-col cols="2" class="right"><label class="form__label">{{ $t("messages.login.repeatPassword") }}</label></b-col>
                            <b-col cols="10" class="right"><input class="form-control" type="password" v-model.trim="$v.form.repeatPassword.$model" data-vv-validate-on="blur" /></b-col>
                        </b-row>
                        <b-row v-if="$v.form.$error">
                            <div class="error" v-if="!$v.form.repeatPassword.sameAsPassword"> {{ $t('messages.login.error.passwordIdentical') }}</div>
                        </b-row>
                        <button type="submit" class="button">
                            <!-- Update password -->
                            {{ $t("messages.updatePassword") }}
                        </button>
                    </form>
                </b-col>
            </b-row>
        </div>
    </div>
    <modal name="login-box"
        transition="nice-modal-fade"
        :min-width="200"
        :min-height="250"
        :pivot-y="0.5"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="30%"
        height="auto"
        :clickToClose="false">
        <div class="modal-detail-content">
            <b-row>
                <b-btn @click="$modal.hide('login-box');" class="closePopup"> <icon name="times-circle"></icon> </b-btn>
            </b-row>
            <b-col>
                <login-box v-on:onLogin="onLogin"></login-box>
            </b-col>
        </div>
    </modal>
</div>
</template>

<script>
import {
    mapState
} from 'vuex';
import FileSelect from './utils/FileSelect.vue'
import LoginBox from './utils/LoginBox.vue'
import {required,email, sameAs,  minLength} from 'vuelidate/lib/validators';
const {fb,auth} = require('../firebaseConfig.js')

export default {
    components: {
        FileSelect,
        LoginBox
    },
    data() {
        return {
            boolean: true,
            email:'',
            lang: '',
            file: null,
            selectedFile: null,
            pools:[],
            form: {
                password: "",
                repeatPassword:"",
            },

        }
    },
    validations: {
        userProfile: {
            name: {
                required,
                minLength: minLength(4)
            },
            country:{
              required  
            }
        },
        form: {
            password: {
                required,
                minLength: minLength(6)
            },
            repeatPassword: {
                sameAsPassword: sameAs('password')
            }
        }
    },
    created(){
      this.setCountries()
      
    },
    computed: {
        ...mapState(['userProfile', 'languages', 'backgrounds', 'currentUser', 'userImage']),
        countriesList: function () {
            var index =  this.languages.map((o) => o.code).indexOf(this.$i18n.locale);
            return this.languages[index].countries;
        },

        fillPools: function(){
            var arr = this.userProfile.pools;
            var _tmp = [];
            arr.forEach(id => {
                this.$store.dispatch("getPoolById", { id: id}).then(pool => {
                    if (pool && pool.main.version >= 830) { //only valid version pools
                        var _name = (pool.form.name!="") ? pool.form.name + ' ('+ pool.id+')' : pool.id;
                        _tmp.push({id: pool.id, name: _name})
                    }
                })
            });
            return _tmp;
        },

    },
    watch: {
      "$i18n.locale": function(oldV, newV) {
        this.setCountries();
        this.setVoicePools();
      }
    },
    methods: {
      setVoicePools(){
          this.pools = this.fillPools
        },
        setCountries(){
          this.countries = this.countriesList
        },
        profile(){
            this.$v.userProfile.$touch();
            if (this.$v.userProfile.$error){
                return
            }
            this.updateProfile();
        },
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$error){
                return
            }
           this.updateProfilePassword();
        },

        onLogin(login){
            var credential = fb.auth.EmailAuthProvider.credential(
                this.currentUser.email,
                login.password
            );
            this.currentUser.reauthenticateAndRetrieveDataWithCredential(credential).then( () => {
                // Re-authenticated user
               console.log('Re-authenticated user');
                this.$modal.hide('login-box');
                this.updateProfilePassword();
            }).catch(function(error) {
                console.log(error);
            });
        },
        updateProfilePassword() {
            // Updating password / Sending data
            this.$snotify.async( this.$t("messages.alertUpdatingPassword"), () => new Promise((resolve, reject) => {
                this.currentUser.updatePassword(this.form.password).then( ()=> {
                    this.$v.form.$reset();
                    this.form.password = '';
                    this.form.repeatPassword = '';
                    resolve({
                        // Password updated
                        body: this.$t("messages.passwordUpdated"),
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    this.$modal.show('login-box');
                    reject()
                });
            }))  
        },
        updateProfile() {
            // Updating user profile / Sending data
            this.$snotify.async( this.$t("messages.alertUpdatingUser"), () => new Promise((resolve, reject) => {
                this.$store.dispatch('updateProfile',
                  this.userProfile
                ).then(response => {
                    //this.$store.dispatch('changeStyle', { val: this.userProfile.uiBackground})
                   resolve({
                    //    User updated
                        body: this.$t("messages.userUpdated"),
                        config: {
                            timeout: 1000,
                            closeOnClick: true
                        }
                    })
                }, error => {
                    reject({
                        // Error updating user
                        body: this.$t("messages.userUpdateError"),
                        config: {
                            timeout: 3000,
                            closeOnClick: true
                        }
                    })
                });
            }))
        }
    }
}
</script>

<style scoped>
.boxLogin .col {
    min-height: 262px;
}

.userImage {
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 50%;

    object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue